import { useLayoutEffect } from 'react';
import { useFormikContext } from 'formik';
import { useFolioDrawerContext } from './FolioDrawerContext';

/**
 * Asks the surrounding FolioDrawer to confirm before closing while the Formik form is dirty.
 * Renders nothing, and does nothing when the form is not inside a FolioDrawer.
 * Place it anywhere inside the Formik `<Form>`, e.g. `<FolioDrawerFormGuard />`.
 */
export const FolioDrawerFormGuard = () => {
	const { dirty } = useFormikContext();
	const setIsFormDirty = useFolioDrawerContext()?.setIsFormDirty;

	// Layout effect so the drawer knows as soon as the form re-renders, before any close check.
	useLayoutEffect(() => {
		if (!setIsFormDirty) return;
		setIsFormDirty(dirty);
		return () => setIsFormDirty(false);
	}, [dirty, setIsFormDirty]);

	return null;
};

export default FolioDrawerFormGuard;
